import loadingActionReducer from "./Loader";
import topPlaceActionReducer from "./TopPlaces";
import userDetailReducer from "./GetUserDetails";
import changeViewReducer from "./ChangeView";
import addPointNotificationReducer from "./AddPointNotification";
import buyPointNotificationReducer from "./BuyPointNotification";
import { combineReducers } from "redux";
import pointListReducer from "./PointList";
import checkboxReducer from "./Checkbox";
// import changeDistanceReducer from "./ChangeDistance";

const rootReducer = combineReducers({
    loadingActionReducer,
    topPlaceActionReducer,
    userDetailReducer,
    changeViewReducer,
    addPointNotificationReducer,
    buyPointNotificationReducer,
    pointListReducer,
    checkboxReducer,
    // changeDistanceReducer
});

export default rootReducer;